import { connect } from 'react-redux'
import ProfileSelector from './component'
import { actions, selectors } from '../../imports'
import {
    // Actions
    hideSelector,

    // Selectors
    isOpen,
    getUserId,
    getTitle,
    getBoundingRectangle,
    getManageProfilesText,
} from '../../data'

function mapStateToProps(state) {
    const userId = getUserId(state)
    const userProfile = selectors.getActiveUserProfile(state, userId)
    return {
        userProfile,
        profiles: selectors.getActiveServerProfiles(state),
        boundingRectangle: getBoundingRectangle(state),
        title: getTitle(state),
        manageProfilesText: getManageProfilesText(state),
        open: isOpen(state),
    }
}

const setProfile = profile => (dispatch, getState) => {
    const state = getState()
    const userId = getUserId(state)
    const serverId = selectors.getActiveServerId(state)
    dispatch(actions.setUserProfile(serverId, userId, profile))
}

function mapDispatchToProps(dispatch) {
    return {
        setProfile: (profile) => {
            dispatch(setProfile(profile))
        },
        dismiss: () => {
            dispatch(hideSelector())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSelector)



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/components/Selector/index.js